import { Component, Input, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { ToastrService } from "ngx-toastr";
import { CommanSubscribeService } from "./../../../core/services/comman-subscribe.service";
import { COLORLIST } from "./../../../core/constants";
import { API } from "aws-amplify";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CONST_AWS_API } from "src/app/core/constants";
import { Subscription } from "rxjs";
import { PubNubService } from "src/app/core/services/pubnub.service";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";
import { UserService } from "src/app/core/services/user.service";
import * as moment from "moment";
declare let $: any;

@Component({
  selector: "app-private-chat",
  templateUrl: "./private-chat.component.html",
  styleUrls: ["./private-chat.component.scss"],
})
export class PrivateChatComponent implements OnInit {
  open: boolean;
  userInfo: any = {};
  userInfoSubscription: Subscription;
  searchContact: any = "";
  searchContactsData: any;
  userColor: any = {};
  countUserColor = 0;
  content: string = "Contacts";
  showLoader: boolean = false;
  contactsList: any;
  name: any;
  redirectTo: any = "Contacts";
  //chat code starts
  isCheckingChannel: boolean = false;
  isChannelAvailable: boolean = false;
  sb: any;
  channelHandler: any;
  openChannel: any;
  messageList: any = [];
  sendMessageText: any = "";
  // messageSubscriber: Subscription;
  messageSubscriber: any;
  contactData: any;
  groupChannel: any;
  isShowEmoji: boolean = false;
  toggleViewContact: boolean = false;
  isBlockContact: boolean = false;
  path: any;
  fansList: any = [];
  chatStatusSubscr: any;
  eventId: any;
  fansMsgData: any = [];
  msgCount: any = [];
  contactInfoSubscription: Subscription;
  contactInfo: any = {};
  openPrivateChat: boolean = false;
  slugInfo: any;
  slugInfoSubscr: Subscription;
  streamId: any;
  groupChannels: any;
  routerevents: any;
  assets_url = environment.assets_url;
  productList: any;
  stream_menu = environment.clientDetails.stream_menu;
  performerInfoSubscr:Subscription;
  channelName: string = '';
  settingsData: any = {};
  settingsDataSubscription: Subscription;
  constructor(
    private userService: UserService,
    private ngxLoader: NgxUiLoaderService,
    public router: Router,
    private route: ActivatedRoute,
    private pubnubService: PubNubService,
    private toastr: ToastrService,
    private commonSubscribeService: CommanSubscribeService
  ) {
    this.routerevents = router.events.subscribe((val) => {
      // if (this.router.url.includes('/stream/') || this.router.url.includes('/event/schedule/')){
      // this.content = 'Fans Online';
      // }else{
      this.content = "Contacts";
      // }
    });
  }

  ngOnInit() {
    this.userInfo = this.commonSubscribeService.userInfo;
    let ticket_key, splits;
    let streamUrl = this.router.url.split("/");
    ticket_key =
      this.router.url.includes("/stream/") ||
      this.router.url.includes("/watch/")
        ? streamUrl[2]
        : streamUrl[3];
    if (ticket_key && ticket_key.includes("-")) {
      splits = ticket_key.split("-");
      this.eventId = splits[0];
      if (Object.keys(this.userInfo)?.length == 0) {
        this.userInfo.id = splits ? splits[1] : "";
      }
    }
    this.getContactsList();
    this.slugInfoSubscr = this.commonSubscribeService
      .getSlugData()
      .subscribe((response) => {
        this.slugInfo = response;
        this.streamId = this.streamId ? this.streamId : this.slugInfo?.streamid;
      });
    this.commonSubscribeService
      .getActiveProductsList()
      .subscribe((response) => {
        this.productList = response;
      });

    this.userInfoSubscription = this.commonSubscribeService
      .getUserInfo()
      .subscribe((response) => {
        this.userInfo = response;
        if (Object.keys(this.userInfo)?.length == 0) {
          this.userInfo.id = splits[1];
        }
        this.getContactsList();
        // if (this.router.url.includes('/stream/') || this.router.url.includes('/event/schedule/'))
        //   this.goToFansList();
        this.chatStatusSubscr = this.userService
          .getStatus()
          .subscribe((response) => {
            this.openPrivateChat = response;
            // if(!this.openPrivateChat){
            this.contactInfo = {};
            // }
            // this.content = 'Fans Online';
            this.content = "Contacts";
            if (response) this.open = true;
            // if(this.openPrivateChat)
            //   this.goToFansList();
            // if (response != 'onLoad')
            // this.openContactBox();
          });
        this.contactInfo = this.commonSubscribeService.contactInfo;
        this.contactInfoSubscription = this.commonSubscribeService
          .getContactDetails()
          .subscribe((response) => {
            setTimeout(() => {
              this.openPrivateChat = true;
              // this.redirectTo = 'Fans Online';
              this.redirectTo = "Contacts";
              this.contactInfo = response;
              this.contactInfo.name = response._sender.nickname;
              this.contactInfo.userColor = response._sender.userColor;
              this.contactInfo.shortName = response._sender.shortName;
              (this.contactInfo.profile_pic = response._sender.profileUrl),
                (this.contactInfo.user_id = response._sender.userId);
              if (this.fansList && this.fansList.length > 0) {
                this.fansList.forEach((element) => {
                  if (element.user_id == this.contactInfo.user_id)
                    this.contactInfo = element;
                });
              }
              this.open = true;
              // this.startChat(this.contactInfo, 'Fans Online');
              this.startChat(this.contactInfo, "Contacts");
            }, 1000);
          });
      });
      let perfomerInfoData = this.commonSubscribeService.perfomerInfoData;
      if(perfomerInfoData && Object.keys(perfomerInfoData).length != 0) {
        perfomerInfoData = this.commonSubscribeService.perfomerInfoData;
      }
      this.channelName= perfomerInfoData.data ? perfomerInfoData.data.Data[0].channel_display_name : '';
      this.settingsData = this.channelName ? this.commonSubscribeService.icWebpageSettingsData : {};
      this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(response => {
        if (this.channelName) {
          this.settingsData = response;
        }
      });
      this.settingsDataSubscription = this.commonSubscribeService.getStreamWebpageStyles().subscribe(async (response) => {
        this.settingsData = response;
      });
      this.performerInfoSubscr = this.commonSubscribeService.getPerfomerInfo().subscribe(response => {
        perfomerInfoData =response;
        this.channelName = perfomerInfoData?.data?.Data?.[0]?.channel_display_name;
        this.settingsData = this.channelName ? this.commonSubscribeService.icWebpageSettingsData : {};
      })
    this.connectToNotificationChannel();
  }


  updateMenuBackground() {
    const networkMenuContentElements = document.querySelectorAll('.mat-menu-content');
    networkMenuContentElements.forEach((el: HTMLElement) => {
      el.style.backgroundColor = this.settingsData?.bg_primary_color;
    });
  }

  updateEmojiBackground() {
    if (this.settingsData?.form_bg_color) {
      const styles = [
        { selector: '.emoji-mart', color: this.settingsData.bg_primary_color },
        { selector: '.emoji-mart-search input', color: this.settingsData.form_bg_color }
      ];
    
      styles.forEach(({ selector, color }) => {
        document.querySelectorAll<HTMLElement>(selector).forEach(el => {
          el.style.backgroundColor = color;
        });
      });
    }
  }

  openContactBox(type?) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Contacts Chat Clicked By - ${userId}`);
    const data = {
      actionType: "event",
      metaData: {
        title: "Contacts Chat Clicked",
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commonSubscribeService?.slugInfo?.organization_id || null,

    }
    this.commonSubscribeService.sendTriggeredEvent(data);
    if (!type) {
      this.open = !this.open;
      // if (this.router.url.includes('/stream/') || this.router.url.includes('/event/schedule/') && this.redirectTo != 'Fans Online')
      //   this.goToFansList();
    }
  }

  goToFansList() {
    this.content = "Fans Online";
    this.searchContact = "";
    this.getFansList();
  }

  getFansList() {
    let ticket_key, splits;
    let streamUrl = this.router.url.split("/");
    ticket_key =
      this.router.url.includes("/stream/") ||
      this.router.url.includes("/watch/")
        ? streamUrl[2]
        : streamUrl[3];
    if (ticket_key && ticket_key.includes("-")) {
      splits = ticket_key.split("-");
      this.eventId = splits[0];
      if (Object.keys(this.userInfo)?.length == 0) {
        this.userInfo.id = splits[1];
      }
    }
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {},
    };
    let url = CONST_AWS_API.GET_FANS_BY_EVENT_ID + "/" + this.eventId;
    API.get(environment.AWS_Cognito.apiName, url, data).then(
      (response) => {
        if (response.status == 200) {
          let fansList = response["data"]["Data"];
          (this.fansList = []), (this.msgCount = []);
          fansList.forEach((e) => {
            if (e.user_id != this.userInfo.id) {
              e.userColor = this.getColor(e);
              e.shortName = this.getName(e.name);
              if (
                e.sent &&
                e.sent.indexOf(this.userInfo.id) != -1 &&
                e.accepted.indexOf(this.userInfo.id) == -1
              ) {
                this.fansList.unshift(e);
              } else if (e.accepted.indexOf(this.userInfo.id) != -1) {
                this.fansList.unshift(e);
              } else {
                this.fansList.push(e);
              }
              if (this.fansMsgData && this.fansMsgData.length > 0) {
                this.fansMsgData.forEach((data) => {
                  this.fansList.forEach((element) => {
                    if (element.user_id == data.user_id && data.messageReceived)
                      element.messageReceived = true;
                    else element.messageReceived = false;
                    if (element.messageReceived) {
                      this.msgCount.push(element);
                      this.userService.sendMessageStatus("Private Chat");
                    }
                  });
                });
              }
            }
          });
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  sendRequest(contact) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        event_id: this.eventId,
        from: this.userInfo.id,
        to: contact.user_id,
      },
    };
    API.post(
      environment.AWS_Cognito.apiName,
      CONST_AWS_API.SEND_EVENT_CONTACT_REQUEST,
      data
    )
      .then((response) => {
        if (response.data.statusCode === "200") {
          this.toastr.success("Request sent successfully");
          this.contactData.disableContact = true;
          this.getFansList();
        }
      })
      .catch((error) => {
        this.ngxLoader.stop();
      });
  }

  processContactRequest(contact, type) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        event_id: this.eventId,
        from: this.userInfo.id,
        to: contact.user_id,
        status: type,
      },
    };
    API.post(
      environment.AWS_Cognito.apiName,
      CONST_AWS_API.PROCESS_EVENT_CONTACT_REQUEST,
      data
    )
      .then((response) => {
        if (response.data.statusCode === "200") {
          let reqType = type == "accept" ? "accepted" : "rejected";
          this.toastr.success("Request is " + reqType);
          this.getFansList();
        }
      })
      .catch((error) => {
        this.ngxLoader.stop();
      });
  }

  getContactsList() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        userid: this.userInfo.id,
      },
    };
    API.post(
      environment.AWS_Cognito.apiName,
      CONST_AWS_API.GET_CONTACTS_LIST,
      data
    )
      .then((response) => {
        if (response.data.statusCode === "200") {
          this.contactsList = response["data"]["Data"];
          this.contactsList.forEach((e) => {
            e.name = e.contact_details.name;
            e.contact_details.userColor = this.getColor(e);
            e.contact_details.shortName = this.getName(e.contact_details.name);
          });
          this.connectToNotificationChannel("fromContacts");
        }
      })
      .catch((error) => {
        this.ngxLoader.stop();
      });
  }

  filterContacts() {
    $(".cl-box").keypress(function (event) {
      if (event.which == 13) {
        event.preventDefault();
      }
    });
  }

  getSearchContacts(contact) {
    if (contact != "" && contact.length >= 3) {
      $(".c-box").keypress(function (event) {
        if (event.which == 13) {
          event.preventDefault();
        }
      });
      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          Authorization: `Bearer ${this.userInfo.access_token}`,
        },
        response: true,
        body: {
          searchKey: contact,
        },
      };
      this.showLoader = true;
      API.post(
        environment.AWS_Cognito.apiName,
        CONST_AWS_API.GET_SEARCH_CONTACTS,
        data
      )
        .then((response) => {
          this.showLoader = false;
          if (response.data.statusCode === "200") {
            this.searchContactsData = response.data.Data;
            if (this.searchContactsData.length == 0)
              this.name = this.searchContact.charAt(0);
            if (this.searchContactsData && this.searchContactsData.length > 0) {
              this.searchContactsData.forEach((e) => {
                e.userColor = this.getColor(e);
                e.shortName = this.getName(e.user_display_name);
              });
            }
          }
        })
        .catch((error) => {
          this.ngxLoader.stop();
        });
    }
  }

  getColor(contact, type?) {
    let id = contact.id ? contact.id : contact.contactid;
    id = type == "chat" ? contact._sender.userId : id;
    let color = "";
    if (!this.userColor[id]) {
      color = COLORLIST[this.countUserColor];
      this.userColor[id] = COLORLIST[this.countUserColor];
      if (this.countUserColor > COLORLIST.length) {
        this.countUserColor = 0;
      } else {
        this.countUserColor++;
      }
    } else {
      color = this.userColor[id];
    }
    return color;
  }

  getName(name) {
    let returnString = "";
    if (name) {
      let a = name.split(" ");
      if (a.length > 1) {
        returnString = a[0].charAt(0);
        returnString += a[1].charAt(0);
        return returnString;
      } else if (name) {
        returnString = a[0].charAt(0);
        returnString += a[0].charAt(1);
        return returnString;
      } else {
        return returnString;
      }
    }
  }

  addContact(contact) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      const streamId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
      (window as any).umami?.track(`A contact is added to private chat of stream ${streamId} - ${userId}`)
      const u_payload = {
        actionType: "network",
        metaData: {
          title: `A contact is added to private chat of stream ${streamId}`,
          timeStamp: new Date().toISOString()
        },
        organizationId: this.slugInfo?.organization_id || null,
        clickAction: `stream`
      }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        userid: this.userInfo.id,
        contactid: contact.id,
        groupname: "null",
        contact_details: {
          name: contact.user_display_name,
          phone_number: contact.user_phone_number,
          email: contact.email,
          profile_pic: contact.profile_pic,
        },
      },
    };
    API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.ADD_CONTACT, data)
      .then((response) => {
        if (response.data.statusCode === "200") {
          let contactsList = this.searchContactsData;
          contactsList.forEach((element) => {
            if (element.id == contact.id) element.isAddedContact = true;
            // this.searchContactsData.push(element);
          });
          this.toastr.success("Contact added successfully");
          let contactData = {
            userid: this.userInfo.id,
            contactid: contact.id,
            groupname: "null",
            contact_details: {
              name: contact.user_display_name,
              phone_number: contact.user_phone_number,
              email: contact.email,
              profile_pic: contact.profile_pic,
            },
            isAddedContact: true,
          };
          contactData.contact_details["userColor"] = this.getColor(contactData);
          contactData.contact_details["shortName"] = this.getName(
            contactData.contact_details.name
          );
          this.contactData = contactData;
        }
      })
      .catch((error) => {
        this.ngxLoader.stop();
      });
  }

  goToAddContact() {
    this.searchContact = "";
    this.content = "Add Contact";
  }

  viewContact(from?) {
    this.toggleViewContact = !this.toggleViewContact;
    if (from == "fans") this.getSelectedContactDetails();
  }

  getSelectedContactDetails() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {},
    };
    let url =
      CONST_AWS_API.GET_CONTACT_DETAILS + "/" + this.contactData.user_id;
    API.get(environment.AWS_Cognito.apiName, url, data)
      .then((response) => {
        if (response.data.statusCode === "200") {
          let contactData = response["data"]["Data"];
          this.contactData.contact_details = {
            email: contactData.email,
            phone_number: contactData.user_phone_number,
            profile_pic: contactData.profile_pic,
            name: contactData.user_display_name,
            userColor: this.contactData.userColor,
            shortName: this.contactData.shortName,
          };
        }
      })
      .catch((error) => {
        this.ngxLoader.stop();
      });
  }

  backToContacts() {
    if (this.contactInfo && this.contactInfo.name && !this.toggleViewContact) {
      this.contactInfo = {};
      this.open = false;
      this.openPrivateChat = false;
      this.userService.sendContactStatus(true);
      return;
    }
    if (this.toggleViewContact) {
      this.toggleViewContact = !this.toggleViewContact;
      // if (this.redirectTo == 'Fans Online')
      //   this.startChat(this.contactData, 'Fans Online');
      // else
      //   this.startChat(this.contactData, 'Contacts');
    } else {
      let redirectTo =
        this.redirectTo == "Fans Online" ? "Fans Online" : "Add Contact";
      this.content = this.redirectTo == "Contacts" ? "Contacts" : redirectTo;
      this.searchContact = "";
      if (this.content == "Contacts") this.getContactsList();
      else this.getFansList();
      this.connectToNotificationChannel();
    }
  }

  inviteContact() {
    const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    if (EMAIL_REGEX.test(this.searchContact) == false) {
      this.toastr.error("Please enter valid email");
      return false;
    } else {
      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          Authorization: `Bearer ${this.userInfo.access_token}`,
        },
        response: true,
        body: {
          userid: this.userInfo.id,
          email: this.searchContact,
          inviter_details: {
            name: this.userInfo.user_display_name,
            email: this.userInfo.email,
            profile_pic: this.userInfo.profile_pic,
          },
        },
      };
      API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.INVITE_USER, data)
        .then((response) => {
          if (response.data.statusCode === "200") {
            this.toastr.success("Invited successfully");
          } else if (response.message == "Internal server error") {
            // this.toastr.info('So')
          }
        })
        .catch((error) => {
          this.ngxLoader.stop();
        });
    }
  }

  goToContactsList() {
    this.content = "Contacts";
    this.searchContactsData = [];
    this.searchContact = "";
    this.getContactsList();
  }

  startChat(contact, from) {
    if (this.openPrivateChat) this.userService.sendMessageStatus("");
    this.pubnubService.init();
    // this.sbService.init();
    // this.sb = this.sbService.sb;
    this.content = contact.name ? contact.name : contact.contact_details.name;
    // if (from == 'Fans Online') {
    contact.contact_details = {
      name: contact.name,
      userColor: contact.userColor
        ? contact.userColor
        : contact.contact_details.userColor,
      shortName: contact.shortName
        ? contact.shortName
        : contact.contact_details.shortName,
      profile_pic: contact.profile_pic
        ? contact.profile_pic
        : contact.contact_details.profile_pic,
    };
    // }
    this.contactData = contact;
    this.contactData.disableContact = false;
    this.redirectTo = from;
    if (this.fansMsgData && this.fansMsgData.length > 0) {
      this.fansMsgData.forEach((data) => {
        if (data.user_id == contact.user_id) data.messageReceived = false;
      });
    }
    this.fansList.forEach((element) => {
      if (element.user_id == contact.user_id && element.messageReceived)
        element.messageReceived = false;
    });
    this.connectChannels(contact);
  }

  connectChannels(contact) {
    this.isCheckingChannel = false;
    this.pubnubService.connect(
      this.userInfo && this.userInfo.id.toString(),
      (success, error) => {
        if (error) {
          this.isCheckingChannel = false;
          console.log("Error while connecting chat user", error);
          this.isChannelAvailable = false;
          // this.toastr.error("Error while connecting chat user");
          return;
        } else {
          let id = contact.contactid ? contact.contactid : contact.user_id;
          let min = Math.min(this.userInfo.id, id);
          let max = Math.max(this.userInfo.id, id);
          var userIds = [this.userInfo.id, id];
          // When 'distinct' is false
          let enterGroupChannel = this.pubnubService.enterGroupChannel(userIds);
          if (enterGroupChannel) {
            for (let id in userIds) {
              this.pubnubService.connect(
                id.toString(),
                (groupChannel, error) => {
                  if (error) {
                    return;
                  } else {
                    this.pubnubService.enterChannel(
                      min + "_" + max,
                      1,
                      (openChannel, error) => {
                        if (error) {
                          return;
                        }
                        console.log(openChannel);
                        this.groupChannel = openChannel;
                        // this.getChannel();
                        this.loadMessages();
                      }
                    );
                  }
                }
              );
            }
          }
        }
      }
    );
  }

  loadMessages() {
    let messages = [];
    this.pubnubService.getAllMessages(
      this.groupChannel,
      (messageList, status) => {
        if (status.error) {
          console.log("Error while loading messages", status.error);
          // this.toastr.error("Error while loading messages");
          return;
        }

        messageList.forEach((e) => {
          const timestampMs = e.timetoken / 10_000;
          const formattedDate = moment(timestampMs)
            .local()
            .format("YYYY-MM-DD h:mm A");
          let message = e.entry.message;
          let time = formattedDate;
          e = e.entry;
          if (e._sender) {
            e._sender.userColor = this.getColor(e, "chat");
            e._sender.shortName = this.getName(e._sender.nickname);
            if (e._sender.userId == this.userInfo.id) e._sender.isSender = true;
          }
          messages.push({ ...e, message: message, time: time });
        });
        this.isCheckingChannel = true;
        this.messageList = messages;
        setTimeout(() => {
          this.setScrollBottom();
        }, 100);
      }
    );
    this.pubnubService.receiveMessages(this.groupChannel, (response) => {
      let channel = response.channel;
      let message = response.message;
      let isUniqueMessage = !this.messageList.some(
        (m) => m.messageId == message.messageId
      );
      if (
        channel &&
        this.groupChannel &&
        channel == this.groupChannel &&
        isUniqueMessage
      ) {
        message._sender.isSender = this.userInfo.id === message._sender.userId;
        message._sender.userColor = this.getColor(message, "chat");
        message._sender.shortName = this.getName(message._sender.nickname);
        const timestampMs = response.timetoken / 10_000;
        const formattedDate = moment(timestampMs)
          .local()
          .format("YYYY-MM-DD h:mm A");
        message.time = formattedDate;
        var div = document.getElementById("p-chat-inner-box");
        // Adjusted the calculation to include a buffer of 20 to ensure new messages are visible even with minor height discrepancies
        if (div && div.scrollHeight - div.scrollTop <= div.clientHeight + 20) {
          this.messageList.push(message);
          setTimeout(() => {
            this.setScrollBottom();
          }, 100);
        } else {
          this.messageList.push(message);
        }
      }
    });
  }

  setScrollBottom() {
    var div1 = document.getElementById("p-chat-inner-box");
    if (div1) {
      $("#p-chat-inner-box").animate(
        {
          scrollTop: div1.scrollHeight - div1.clientHeight,
        },
        500
      );
    }
  }

  connectToNotificationChannel(message?) {
    this.pubnubService.init();
    this.pubnubService.connect(
      this.userInfo && this.userInfo?.id?.toString(),
      (success, error) => {
        if (error) {
          this.isCheckingChannel = false;
          console.log("Error while connecting chat user", error);
          this.isChannelAvailable = false;
          // this.toastr.error("Error while connecting chat user");
          return;
        } else {
          this.pubnubService.enterChannel(
            "notifications",
            1,
            (openChannel, error) => {
              if (error) {
                this.isCheckingChannel = false;
                console.log("Error while connecting chat channel", error);
                this.isChannelAvailable = false;
                // this.toastr.error("Channel not available");
                return;
              }
              this.pubnubService.enterChannel(
                openChannel,
                1,
                (response, error) => {
                  if (error) {
                    console.log("Error while enter chat channel", error);
                    this.isChannelAvailable = false;
                    this.isCheckingChannel = false;
                    return;
                  }
                  this.isCheckingChannel = true;
                  this.isChannelAvailable = true;
                  this.openChannel = openChannel;
                  if (message != "fromContacts") {
                    this.sendToNotificationChannel(message);
                  }
                  // if (!this.messageSubscriber) {
                  this.pubnubService.receiveMessages(
                    openChannel,
                    (response) => {
                      let membersList: any = [];
                      let channel = response.channel;
                      membersList = channel.members;
                      let message = response.message;
                      let receiverId;
                      if (message.data)
                        receiverId =
                          typeof message.data == "string"
                            ? JSON.parse(message.data)
                            : message.data;
                      if (
                        receiverId &&
                        receiverId.to &&
                        receiverId.to == this.userInfo.id
                      ) {
                        if (message._sender.userId) {
                          this.fansList.forEach((element) => {
                            if (
                              element.user_id == message._sender.userId ||
                              element.messageReceived
                            )
                              element.messageReceived = true;
                            else element.messageReceived = false;
                          });
                        }
                      } else {
                        if (membersList && membersList.length > 0) {
                          membersList.forEach((mem) => {
                            this.fansList.forEach((element) => {
                              if (
                                mem.userId == element.user_id ||
                                element.messageReceived
                              )
                                element.messageReceived = true;
                              else element.messageReceived = false;
                              if (element.messageReceived) {
                                this.msgCount.push(element);
                                this.userService.sendMessageStatus(
                                  "Private Chat"
                                );
                              }
                            });
                          });
                        }
                      }
                      this.fansMsgData = this.fansList;
                    }
                  );
                }
              );
            }
          );
        }
      }
    );
  }

  getTime(date?: Date) {
    return date != null ? date.getTime() : 0;
  }

  sortByDueDate(from?): void {
    if (this.contactsList && this.contactsList.length > 0) {
      this.contactsList.sort((a: any, b: any) => {
        return <any>b.created_time - <any>a.created_time;
      });
    }
  }

  sendToNotificationChannel(message) {
    if (!this.openChannel) {
      this.toastr.error("Chat channels not connected");
      return;
    }

    let sendMessageText = message;
    if (sendMessageText) {
      const params: any = {};
      params.message = sendMessageText;
      params.messageId = Date.now();
      params.data = {
        to: this.contactData.user_id,
      };
      params.data = JSON.stringify(params.data);
      params._sender = {
        profileUrl: this.userInfo.profie_pic || "",
        userId: this.userInfo.id,
        nickname: this.userInfo.user_display_name,
      };
      params.customType = "CUSTOM_TYPE";
      this.pubnubService.sendMessage(
        "notifications",
        params,
        (status, response) => {
          if (status.error) {
            console.log("Error while sending message", status);
            this.toastr.error("Error while sending message");
            return;
          }
          sendMessageText = "";
          setTimeout(() => {
            this.setScrollBottom();
          }, 100);
        }
      );
    }
  }

  openCloseEmoji() {
    this.isShowEmoji = !this.isShowEmoji;
    this.updateEmojiBackground();
  }
  addEmoji(event) {
    if (event.emoji && event.emoji.native) {
      this.sendMessageText += " " + event.emoji.native;
    }
  }

  sendMessage() {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    const streamId = this.commonSubscribeService.extractIdFromUrl(this.router.url);
    (window as any).umami?.track(`A message was sent in private-chat of stream ${streamId} - ${userId}`)
    const u_payload = {
      actionType: "network",
      metaData: {
        title: `A message was sent in private-chat of stream ${streamId} - ${userId}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.slugInfo?.organization_id || null,
      clickAction: `stream`
    }
    this.commonSubscribeService.sendTriggeredEvent(u_payload);
    
    if (!this.groupChannel) {
      this.toastr.error("Chat channels not connected");
      return;
    }

    let sendMessageText = this.sendMessageText,
      sentMessage = this.sendMessageText;
    setTimeout(() => {
      this.sendMessageText = "";
    }, 10);

    if (sendMessageText) {
      const params: any = {};
      params.message = sendMessageText;
      params.messageId = Date.now();
      params.customType = "CUSTOM_TYPE";
      params._sender = {
        profileUrl: this.userInfo.profie_pic || "",
        userId: this.userInfo.id,
        nickname: this.userInfo.user_display_name,
      };
      this.pubnubService.sendMessage(
        this.groupChannel,
        params,
        (status, response) => {
          console.log("response while sending message", response);
          let userMessage = response.message;
          if (status.error) {
            console.log("Error while sending message", status);
            this.toastr.error("Error while sending message");
            return;
          }
          sendMessageText = "";
          this.isShowEmoji = false;
          userMessage._sender.userColor = this.getColor(userMessage, "chat");
          userMessage._sender.shortName = this.getName(
            userMessage._sender.nickname
          );
          userMessage._sender.isSender = true;
          const timestampMs = response.timetoken / 10_000;
          const formattedDate = moment(timestampMs)
            .local()
            .format("YYYY-MM-DD h:mm A");
          userMessage.time = formattedDate;
          setTimeout(() => {
            this.setScrollBottom();
          }, 100);
          this.connectToNotificationChannel(sentMessage);
        }
      );
    }
  }

  blockContact() {
    this.isBlockContact = true;
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        userid: this.userInfo.id,
        contactid: this.contactData.contactid
          ? this.contactData.contactid
          : this.contactData.user_id,
      },
    };
    API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.BLOCK_CONTACT, data)
      .then((response) => {
        if (response.data.statusCode === "200") {
          this.toastr.success("Contact blocked successfully");
          let text =
            this.router.url.includes("/stream/") ||
            this.router.url.includes("/event/schedule/")
              ? "Fans Online"
              : "Add Contact";
          this.content = this.redirectTo == "Contacts" ? "Contacts" : text;
          this.searchContact = "";
          if (this.content == "Contacts") this.getContactsList();
          if (this.content == "Add Contact") this.searchContactsData = [];
          if (this.content == "Fans Online") this.goToFansList();
        }
      })
      .catch((error) => {
        this.ngxLoader.stop();
      });
  }

  clearChatHistory() {
    this.groupChannel.resetMyHistory((response, error) => {
      if (error) {
        return;
      }
      this.messageList = [];
    });
  }

  // Declining an invitation
  declineInvitation() {
    this.groupChannel.declineInvitation((response, error) => {
      if (error) {
        return;
      }
    });
  }

  ngOnDestroy() {
    this.pubnubService.disconnect([this.groupChannel, "notifications"]);
    if (this.userInfoSubscription) this.userInfoSubscription.unsubscribe();
    if (this.chatStatusSubscr) this.chatStatusSubscr.unsubscribe();
    if (this.contactInfoSubscription)
      this.contactInfoSubscription.unsubscribe();
    if (this.slugInfoSubscr) this.slugInfoSubscr.unsubscribe();
  }
}
